function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '../../co-emitter';
import { guid } from '@okee-uikit/react-utils';
export var DomNode = function (_Emitter) {
  _inherits(DomNode, _Emitter);

  var _super = _createSuper(DomNode);

  function DomNode(value) {
    var _this;

    var parentNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, DomNode);

    _this = _super.call(this);
    _this.id = guid();
    _this.firstChild = null;
    _this.lastChild = null;
    _this.leftNode = null;
    _this.rightNode = null;
    _this.parentNode = null;
    _this.parentNode = parentNode;
    _this.value = value;

    if (parentNode) {
      parentNode.appendChild(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(DomNode, [{
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (value !== this.value) {
        var old = this.value;
        this.value = value;
        this.emit('valueChange', value, old);
      }
    }
  }, {
    key: "getPathNodes",
    value: function getPathNodes(filter) {
      var result = [];
      var node = this;

      while (node) {
        if (filter(node)) {
          result.unshift(node);
        }

        node = node.parentNode;
      }

      return result;
    }
  }, {
    key: "getPathKeys",
    value: function getPathKeys(processor) {
      var result = [];
      var node = this;

      while (node) {
        var str = processor(node);

        if (str != null) {
          result.unshift(str);
        }

        node = node.parentNode;
      }

      return result;
    }
  }, {
    key: "remove",
    value: function remove() {
      this.removeNode();
    }
  }, {
    key: "appendChild",
    value: function appendChild(node) {
      var oldParentNode = node.parentNode;
      node.removeNode(true, oldParentNode === this);
      node.parentNode = this;

      if (this.lastChild == null) {
        this.lastChild = this.firstChild = node;
      } else {
        var lastNode = this.lastChild;
        this.lastChild = node;
        lastNode.rightNode = node;
        node.leftNode = lastNode;
      }

      if (!oldParentNode) {
        node.emit('attached');
      }

      this.emit('childChange');
    }
  }, {
    key: "removeChild",
    value: function removeChild(node) {
      node.remove();
    }
  }, {
    key: "replaceChild",
    value: function replaceChild(node, refNode) {
      if (!refNode || refNode.parentNode !== this) {
        throw new Error('replaceChild: refNode is null or not in current Node, place check the code.');
      }

      if (node === refNode) {
        return refNode;
      }

      var next = refNode.rightNode;
      refNode.removeNode(false, refNode.parentNode === this);
      this.insertBefore(node, next);
      return refNode;
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(node, refNode) {
      if (refNode && refNode.parentNode !== this) {
        throw new Error('insertAfter: refNode is not in current Node, place check the code.');
      }

      var oldParentNode = node.parentNode;
      node.removeNode(true, oldParentNode === this);
      node.parentNode = this;

      if (refNode == null) {
        var firstChild = this.firstChild;
        this.firstChild = node;

        if (firstChild == null) {
          this.lastChild = node;
        } else {
          firstChild.leftNode = node;
          node.rightNode = firstChild;
        }
      } else if (refNode === this.firstChild) {
        this.firstChild = node;
        node.rightNode = refNode;
        refNode.leftNode = node;
      } else {
        var leftNode = refNode.leftNode;

        if (leftNode) {
          leftNode.rightNode = node;
        }

        node.leftNode = leftNode;
        node.rightNode = refNode;
        refNode.leftNode = node;
      }

      if (!oldParentNode) {
        node.emit('attached');
      }

      this.emit('childChange');
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(node, refNode) {
      if (refNode && refNode.parentNode !== this) {
        throw new Error('insertAfter: refNode is not in current Node, place check the code.');
      }

      node.remove();
      node.parentNode = this;

      if (refNode == null || refNode === this.lastChild) {
        this.appendChild(node);
        return;
      }

      this.insertBefore(node, refNode.rightNode);
    }
  }, {
    key: "insert",
    value: function insert(node, index) {
      if (index == null) {
        this.appendChild(node);
        return this.getIndex(node);
      }

      var i = 0;
      var cur = this.firstChild;

      while (cur) {
        if (i === index && cur !== node) {
          this.insertBefore(node, cur);
          return index;
        }

        i++;
        cur = cur.rightNode;
      }

      this.appendChild(node);
      return this.getIndex(node);
    }
  }, {
    key: "getIndex",
    value: function getIndex(node) {
      if (!node || node.parentNode !== this) {
        throw new Error('Node.getIndex: node is not in current Node, place check the code.');
      }

      var i = 0;
      var curNode = this.firstChild;

      while (curNode != null && node !== curNode) {
        i++;
        curNode = curNode.rightNode;
      }

      return i;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.firstChild == null;
    }
  }, {
    key: "getChildNodes",
    value: function getChildNodes() {
      var nodes = [];
      var node = this.firstChild;

      while (node != null) {
        nodes.push(node);
        node = node.rightNode;
      }

      return nodes;
    }
  }, {
    key: "getSubNodes",
    value: function getSubNodes(matcher) {
      var nodeList = this.getChildNodes();
      var matched = [];

      while (nodeList.length) {
        var node = nodeList[0];
        var type = matcher(node);
        nodeList.shift();

        if (type === null) {
          nodeList.unshift.apply(nodeList, _toConsumableArray(node.getChildNodes()));
        } else if (type) {
          matched.push(node);
        }
      }

      return matched;
    }
  }, {
    key: "getSubNode",
    value: function getSubNode(matcher) {
      var nodeList = this.getChildNodes();

      while (nodeList.length) {
        var node = nodeList[0];
        var type = matcher(node);

        if (type === null) {
          nodeList.push.apply(nodeList, _toConsumableArray(node.getChildNodes()));
        } else if (type) {
          return node;
        }

        nodeList.shift();
      }

      return null;
    }
  }, {
    key: "removeNode",
    value: function removeNode() {
      var isSilent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var avoidParentChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var parentNode = this.parentNode,
          leftNode = this.leftNode,
          rightNode = this.rightNode;

      if (!parentNode) {
        return;
      }

      var firstChild = parentNode.firstChild,
          lastChild = parentNode.lastChild;

      if (this === firstChild) {
        parentNode.firstChild = rightNode;
      }

      if (this === lastChild) {
        parentNode.lastChild = leftNode;
      }

      if (leftNode) {
        leftNode.rightNode = rightNode;
      }

      if (rightNode) {
        rightNode.leftNode = leftNode;
      }

      this.parentNode = null;
      this.leftNode = null;
      this.rightNode = null;

      if (!isSilent) {
        this.emit('detached', parentNode);

        if (!avoidParentChange) {
          parentNode.emit('childChange');
        }
      }
    }
  }]);

  return DomNode;
}(Emitter);